<div>
    <mat-form-field appearance="outline" class="fw-FourthLevelNavigation_MatFormField">
        <mat-select class="fw-FourthLevelNavigation_Matselect" #menuSelect disableOptionCentering panelClass="ap-AccountPicker_Matselect">
            <mat-option *ngFor="let fourthNav of fourthNavLinks" [value]="fourthNav.name" (onSelectionChange)="handleNavigation(fourthNav)">
                <span> {{ fourthNav.name | pershingTranslate}} </span>
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>